import storage from '../storage.js'
import store from '../'
import moment from 'moment'

const measurement = {
  namespaced: true,
  state: {
    todayMeasurements: [],
    todayLastEvaluatedKey: null,
    todayCurrentMeasurement: null,
    searchMeasurements: [],
    searchLastEvaluatedKey: null,
    searchCurrentMeasurement: null,
    refreshDate: null,
    readMaxKey: null,
    params: {
      mobile: 'mobile'
    }
  },

  // getters
  getters: {
    allMeasurementList: (state) => (page) => {
      let key = page + 'Measurements'
      let d = state[key]
      if (!d) {
        return null
      } else {
        return JSON.parse(JSON.stringify(d))
      }
    },

    currentPageId: (state) => (page) => {
      let key = page + 'CurrentMeasurement'
      let d = state[key]
      if (!d) {
        return null
      } else {
        return JSON.parse(JSON.stringify(d))
      }
    },

    availableLastEvaluatedKey: (state) => (page) => {
      let key = page + 'LastEvaluatedKey'
      let d = state[key]
      if (!d) {
        return null
      } else {
        return JSON.parse(JSON.stringify(d))
      }
    }
  },

  // actions
  actions: {
    async refreshList({ state, dispatch }, payload) {
      dispatch('init')

      var params = {}
      params.mobile = 'mobile'
      params.today = 'today'
      if (payload.serial) params.serial = payload.serial

      await store.dispatch('auth/call', {
        api: 'getMeasurements',
        body: params
      })
        .then(data => {
          var now = new Date()
          dispatch('serialize', { key: 'refreshDate', data: now })
          var json = JSON.parse(data)
          var measurementList = json.Items

          var currentPage = JSON.parse(JSON.stringify(state.todayCurrentMeasurement))
          var currentIdFlg = false

          if (measurementList.length !== 0) {
            measurementList.forEach(ele => {
              ele.acquired_at = now
              if (ele.measurement_id === currentPage) currentIdFlg = true
            })
            if (currentPage && !currentIdFlg) {
              dispatch('updateMeasurement', currentPage)
            }
            dispatch('createAllMeasurementList', measurementList)
          }

          dispatch('updateLastEvaluatedKey', json.LastEvaluatedKey)
        })
        .catch(err => {
          console.log('Error:' + err)
          store.dispatch('auth/sendError', {
            capturer:'API: getMeasurements',
            err:err
          })
          if (err.message === 'Server Error') window.location.href = '/server-error'
        })
    },

    async prevMeasurement({ state, dispatch }, payload) {
      dispatch('init')

      var params = {}
      params.mobile = 'mobile'
      params.today = 'today'
      if (payload.serial) params.serial = payload.serial

      if (state.todayLastEvaluatedKey)
        params.lastEvaluatedKey = JSON.stringify(state.todayLastEvaluatedKey)

      await store.dispatch('auth/call', {
        api: 'getMeasurements',
        body: params
      })
        .then(data => {
          var now = new Date()
          var json = JSON.parse(data)
          var measurementList = json.Items
          var allMeasurementList = JSON.parse(JSON.stringify(state.todayMeasurements))

          if (measurementList.length !== 0) {
            measurementList.forEach(ele => {
              var obj = ele
              obj.acquired_at = now
              allMeasurementList.push(obj)
            })
            dispatch('serialize', { key: 'todayMeasurements', data: allMeasurementList})
            dispatch('serialize', { key: 'todayCurrentMeasurement', data: measurementList[0].measurement_id})
          }

          dispatch('updateLastEvaluatedKey', json.LastEvaluatedKey)
        })
        .catch(err => {
          store.dispatch('auth/sendError', {
            capturer:'API: getMeasurements',
            err:err
          })
          if (err.message === 'Server Error') window.location.href = '/server-error'
        })
    },

    async updateMeasurement({ state, dispatch }, currentPage) {
      await store.dispatch('auth/call', {
        api: 'getMeasurementWithId',
        body: {
          measurement_id: currentPage
        }
      })
        .then(data => {
          if (data.length) {
            data = data[0]
            data.acquired_at = new Date()

            dispatch('deserialize', 'todayMeasurements')
            var idList = []
            var measurementList = JSON.parse(JSON.stringify(state.todayMeasurements))
            measurementList.forEach(ele => {
              idList.push(ele.measurement_id.toString())
            })
            var cursol = idList.indexOf(currentPage) === -1 ? 0 : idList.indexOf(currentPage)

            measurementList.splice(cursol, 1, data)
            dispatch('serialize', { key: 'todayMeasurements', data: measurementList })
          } else {
            window.location.href = '/forbidden'
          }
        })
        .catch(err => {
          console.log('Error:' + err)
          store.dispatch('auth/sendError', {
            capturer:'API: getMeasurementWithId',
            err:err
          })
          if (err.message === 'Server Error') window.location.href = '/server-error'
        })
    },

    createAllMeasurementList({ state, dispatch }, latestList) {
      var allMeasurementList = JSON.parse(JSON.stringify(state.todayMeasurements))

      // LSのデータと最新の取得データを比較し、更新されているデータは置き換え、存在しないデータは追加
      if (allMeasurementList) {
        latestList.reverse()
        allMeasurementList.reverse()

        latestList.forEach(latest => {
          var exist = false
          var newDate = moment(latest.updated_at, 'X').format('YYYY-MM-DD HH:mm:ss')
          allMeasurementList.forEach((old, index) => {
            if (latest.measurement_id === old.measurement_id) {
              exist = true
              var oldDate = moment(old.updated_at, 'X').format('YYYY-MM-DD HH:mm:ss')
              if (newDate > oldDate) allMeasurementList[index] = latest
            }
          })
          if (!exist) allMeasurementList.push(latest)
        })
        dispatch('serialize', { key: 'todayMeasurements', data: allMeasurementList.reverse() })
      } else {
        dispatch('serialize', { key: 'todayMeasurements', data: latestList })
      }
    },

    updateLastEvaluatedKey({ state, dispatch }, latestKey) {
      // 有効なlastEvaluatedKeyを更新
      var availableLastEvaluatedKey = JSON.parse(JSON.stringify(state.todayLastEvaluatedKey))
      if (latestKey) {
        if (!availableLastEvaluatedKey || latestKey.location_id < availableLastEvaluatedKey.location_id)
          dispatch('serialize', { key: 'todayLastEvaluatedKey', data: latestKey })
      } else {
        dispatch('serialize', { key: 'todayLastEvaluatedKey', data: null })
      }
    },

    // 検索
    async searchList({ commit, dispatch }, params) {
      dispatch('init')
      commit('setParams', params)
      await store.dispatch('auth/call', {
        api: 'getMeasurements',
        body: params
      })
        .then(data => {
          var json = JSON.parse(data)
          dispatch('serialize', { key: 'searchMeasurements', data: json.Items })

          if (json.LastEvaluatedKey) {
            dispatch('serialize', { key: 'searchLastEvaluatedKey', data: json.LastEvaluatedKey })
          } else {
            dispatch('serialize', { key: 'searchLastEvaluatedKey', data: null })
          }
        })
        .catch(err => {
          console.log('Error:' + err)
          store.dispatch('auth/sendError', {
            capturer:'API: getMeasurements',
            err:err
          })
          if (err.message === 'Server Error') window.location.href = '/server-error'
        })
    },

    async searchPrevList({ state, dispatch }) {
      dispatch('init')
      let params = state.params
      let availableLastEvaluatedKey = state.searchLastEvaluatedKey
      if (availableLastEvaluatedKey) params.lastEvaluatedKey = JSON.stringify(availableLastEvaluatedKey)
      await store.dispatch('auth/call', {
        api: 'getMeasurements',
        body: params
      })
        .then(data => {
          var json = JSON.parse(data)
          var measurementList = json.Items
          var allMeasurementList = JSON.parse(JSON.stringify(state.searchMeasurements))

          if (measurementList.length != 0) {
            measurementList.forEach(ele => allMeasurementList.push(ele))
            dispatch('serialize', { key: 'searchMeasurements', data: allMeasurementList })
            dispatch('serialize', { key: 'searchCurrentMeasurement', data: measurementList[0].measurement_id})
          }

          if (json.LastEvaluatedKey) {
            dispatch('serialize', { key: 'searchLastEvaluatedKey', data: json.LastEvaluatedKey })
          } else {
            dispatch('serialize', { key: 'searchLastEvaluatedKey', data: null })
          }
        })
        .catch(err => {
          console.log('Error:' + err)
          store.dispatch('auth/sendError', {
            capturer:'API: getMeasurements',
            err:err
          })
          if (err.message === 'Server Error') window.location.href = '/server-error'
        })
    },

    init({ state, dispatch }) {
      // storageから最新のデータ・状態を取得
      var keys = Object.keys(state)
      keys.forEach(ele => {
        if (ele !== 'params') dispatch('deserialize', ele)
      })
    },

    serialize({ state }, payload) {
      let cap = store.state.auth.isSuperUser ? storage.getItemToday('cap') : store.state.auth.application
      storage.setItemToday(storage.LocalStorageKeys[payload.key] + '_' + cap, payload.data)
    },

    deserialize({ commit }, payload) {
      let cap = store.state.auth.isSuperUser ? storage.getItemToday('cap') : store.state.auth.application
      let r = storage.getItemToday(storage.LocalStorageKeys[payload] + '_' + cap)
      commit('setStorageData',{ key: payload, r: r})
    },

    initializeToday({ state }) {
      let cap = store.state.auth.isSuperUser ? storage.getItemToday('cap') : store.state.auth.application
      storage.removeItem(storage.LocalStorageKeys['todayMeasurements'] + '_' + cap)
      storage.removeItem(storage.LocalStorageKeys['todayLastEvaluatedKey'] + '_' + cap)
      storage.removeItem(storage.LocalStorageKeys['todayCurrentMeasurement'] + '_' + cap)
    },

    initializeSearch({ state }) {
      let cap = store.state.auth.isSuperUser ? storage.getItemToday('cap') : store.state.auth.application
      storage.removeItem(storage.LocalStorageKeys['searchMeasurements'] + '_' + cap)
      storage.removeItem(storage.LocalStorageKeys['searchLastEvaluatedKey'] + '_' + cap)
      storage.removeItem(storage.LocalStorageKeys['searchCurrentMeasurement'] + '_' + cap)
    }
  },

  // mutations
  mutations: {
    setStorageData(state, data) {
      state[data.key] = data.r
    },

    setParams(state, params) {
      state.params = params
    }
  }
}

export default measurement